import {
  LanguageTestQuestion,
  LanguageTestQuestionInput
} from '../../lib/types/models/language-test/language-test-question'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const createLanguageTestQuestion = ({
  sectionId,
  ...data
}: LanguageTestQuestionInput & { sectionId: number }) => {
  return restApiClient
    .url(constructApiUrl(API.languageTest.createQuestion.url, { sectionId }))
    .post<LanguageTestQuestion, LanguageTestQuestionInput>(data)
}
